function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "e-apm\\u0101c\\u012Bba",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "03.-E---apm\\u0101c\\u012Bba---Atv\\u0113rta-nodarb\\u012Bba",
  transform: "translate(-407.000000, -826.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(294.000000, 70.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Video-block",
  transform: "translate(24.000000, 112.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Controllers",
  transform: "translate(0.000000, 632.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Add-bookmark",
  transform: "translate(77.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon",
  transform: "translate(12.000000, 11.999037)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.80325037,0 C5.45165686,0.60754011 5.20354358,1.28245132 5.08301435,2.00062981 L2,2.00096303 L2,10.468963 L5,8.66858227 L8,10.468963 L8.00003939,8.19829264 C8.60746741,8.54966463 9.28221202,8.79760654 10.0001915,8.91803671 L10,14.000963 L5,11.000963 L0,14.000963 L0,1.71524874 C0,0.819579569 0.670886427,0.082384476 1.52304563,0.00726607056 L1.66666667,0.000963027632 L5.80325037,0 Z M12,0.000963027632 L12,2.00096303 L14,2.00096303 L14,4.00096303 L12,4.00096303 L12,6.00096303 L10,6.00096303 L10,4.00096303 L8,4.00096303 L8,2.00096303 L10,2.00096303 L10,0.000963027632 L12,0.000963027632 Z",
  id: "icon"
}))))))));

function SvgIcAddBookmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3FAAD5B8-44DA-4F77-9270-64A17FAB53E9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddBookmark);
export default __webpack_public_path__ + "static/media/ic-add-bookmark.d6e7798b.svg";
export { ForwardRef as ReactComponent };